export const DESKTOP_SECTION_TOP_OFFSET = 165;

export const MOBILE_SECTION_TOP_OFFSET = 140;
